import React, { useMemo } from 'react';

import { Typography } from 'lighthouse';

import { StarRating } from '@/widgets/StarRating';

import { calculateSatisfaction } from '@/utilities/calculateSatisfaction';

import { RatingSummaryProps } from './models';

export const RatingSummary = ({ reviews }: RatingSummaryProps) => {
    const { average, distribution, total } = useMemo(() => {
        const dist = [0, 0, 0, 0, 0];
        let sum = 0;
        reviews.forEach((review) => {
            const rate = Math.min(5, Math.max(1, Math.round(review.rate)));
            dist[rate - 1] += 1;
            sum += review.rate;
        });
        return {
            average: reviews.length ? sum / reviews.length : 0,
            distribution: dist,
            total: reviews.length
        };
    }, [reviews]);

    if (!total) return null;

    return (
        <div className='flex flex-col items-center gap-4 rounded-lg border border-solid border-gray-100 bg-gray-50 p-4 sm:flex-row sm:gap-8 sm:px-8'>
            <div className='flex flex-col items-center gap-1'>
                <Typography variant='h4' fontWeight={700} className={calculateSatisfaction(average, total).textClassName} component='span'>
                    {average.toFixed(1)}
                </Typography>
                <StarRating size='md' rating={average} />
                <Typography variant='caption' color='blackLowEmphasis'>
                    از مجموع {total} دیدگاه
                </Typography>
            </div>
            <div className='flex w-full flex-1 flex-col gap-1.5'>
                {[5, 4, 3, 2, 1].map((star) => {
                    const count = distribution[star - 1];
                    const percent = total ? Math.round((count / total) * 100) : 0;
                    return (
                        <div key={star} className='flex items-center gap-2'>
                            <Typography variant='caption' color='blackMediumEmphasis' className='w-3 shrink-0 text-center'>
                                {star}
                            </Typography>
                            <div className='h-1.5 flex-1 overflow-hidden rounded-full bg-gray-200'>
                                <div className='h-full rounded-full bg-warning transition-all duration-500' style={{ width: `${percent}%` }} />
                            </div>
                            <Typography variant='caption' color='blackLowEmphasis' className='w-8 shrink-0 text-left'>
                                {count}
                            </Typography>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
